import {
  CreatePasswordValue,
  DetailsValue,
  EmailVerificationRequest,
  EmailVerificationStatusView,
  EmailVerificationValue,
  NotificationPreferencesValue,
  OPACRegistrationValue
} from '@store/registration/registration.types';
import {State} from '@aviary/store/common/common.types';

export const FALLBACK_EMAIL_VERIFICATION_REQUEST: EmailVerificationRequest = {
  email: ''
}

export const FALLBACK_EMAIL_VERIFICATION_VALUE: EmailVerificationValue = {
  verificationCode: ''
}

export const FALLBACK_CREATE_PASSWORD_VALUE: CreatePasswordValue = {
  password: '',
  branchId: 0,
  acceptTerms: false
}

export const FALLBACK_DETAILS_VALUE: DetailsValue = {
  firstName: '',
  lastName: '',
  suffix: '',
  address: '',
  address2: '',
  city: '',
  state: undefined as unknown as State,
  zip: '',
  branchId: 0,
  dateOfBirth: ''
}

export const FALLBACK_NOTIFICATION_PREFERENCES_VALUE: NotificationPreferencesValue = {
  notificationEmail: '',
  mobilePhone: '',
  notifyMethod: 'EMAIL',
  smsTermsAccepted: false
}

export const FALLBACK_REGISTRATION_VALUE: OPACRegistrationValue = {
  firstName: '',
  lastName: '',
  suffix: '',
  address: '',
  address2: '',
  city: '',
  state: '',
  zip: '',
  dateOfBirth: '',
  notifyEmail: false,
  notifyText: false,
  smsTermsAccepted: false,
  notificationEmail: '',
  mobilePhone: '',
  phone1Mobile: false,
  phone1Ext: '',
  phone2: '',
  phone2Mobile: false,
  phone2Ext: '',
  phoneSms: '',
  phoneCall: '',
  password: '',
  verificationUUID: '',
  branchId: 0
}
export const FALLBACK_VERIFICATION_STATUS: EmailVerificationStatusView = {
  email: '',
  expiresAt: '',
  isExistingPatron: false,
  status: 'PENDING'
}
